
const message = {
    verifyMessage:"账号错误或者存在多个，请联系客服处理",
    noGoodsMessage:"未选择商品种类",
    noPayTypeMessage:'未选择支付方式',
    noAcceptMessage:"未同意条款",
    noAccountMessage:"未输入账号",
    buyLinkFailMessage:"获取支付链接失败，请联系客服处理",
}

const buyInfo = {
    topTitleLeft:"口袋外汇",
    topTitleRight:"支付中心",
    buyTitle:"P币",
    account:"口袋账号",
    payMethod:"支付方式",
    payButtonContent:"支付",
    acceptTerms:"我已确认已阅读《服务条款》和《隐私政策》并接受所有条款。",
    inputDefaultContent:"请输入你的口袋账号",
    vipBuyTitle:"VIP会员",
    month:"个月",
    save:"立省",
    noSave:"无折扣",
    mo:"月"
}
const resultInfo = {
    content:"正在查询支付结果...",
    successText:"购买成功",
    buttonText:"返回首页",
    failText:"购买失败"
}
const orderInfo = {
    payment:"支付金额",
}

const title={
    pbTitle:"P币充值",
    vipTitle:"购买Vip会员",
}

export default {buyInfo,resultInfo,orderInfo,message,title}